export default __webpack_public_path__ + "static/media/full screen.48596ff9.svg";